import { Scale } from "lucide-react";
import content from "../../data/content.json";
import { COMPANY } from "../shared/Footer";

export function AboutNotice() {
  const { notice } = content.about;
  return (
    <section data-testid="about-notice" aria-labelledby="about-notice-title" className="mt-12 rounded-md border border-amber-500/30 bg-amber-500/5 p-6 sm:p-8">
      <h2 id="about-notice-title" className="flex items-center gap-3 text-base font-semibold text-slate-100 md:text-lg">
        <Scale aria-hidden="true" className="h-5 w-5 text-amber-400" />{notice.title}
      </h2>
      <ul className="mt-4 space-y-3 text-sm leading-relaxed text-slate-300">
        {notice.items.map((t) => <li key={t}>{t}</li>)}
      </ul>
    </section>
  );
}

const ROWS: [string, string, string][] = [
  ["Razão Social", COMPANY.razaoSocial, "razao-social"],
  ["Nome Fantasia", COMPANY.nomeFantasia, "nome-fantasia"],
  ["CNPJ", COMPANY.cnpj, "cnpj"],
  ["E-mail", COMPANY.email, "email"],
  ["Endereço", COMPANY.endereco, "endereco"],
];

export function AboutTransparency() {
  return (
    <section aria-labelledby="about-transparency-title" className="mt-16">
      <h2 id="about-transparency-title" className="text-base font-semibold text-slate-100 md:text-lg">Transparência corporativa</h2>
      <dl data-testid="about-transparency" className="mt-6 divide-y divide-slate-800 rounded-md border border-slate-800 bg-slate-900">
        {ROWS.map(([k, v, id]) => (
          <div key={id} className="grid gap-1 px-6 py-4 sm:grid-cols-[12rem_1fr]">
            <dt className="font-mono text-xs uppercase text-slate-500">{k}</dt>
            <dd data-testid={`about-${id}`} className="break-words text-sm text-slate-200">{v}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
